module.exports = __webpack_public_path__ + "img/04.74653f1f.png";